module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"cannotDetectFaces":"Impossibile trovare i visi"}}')
  delete Component.options._Ctor
}
